import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import store from '@/store';

@Module({ dynamic: true, store, name: 'process', namespaced: true })
class Process extends VuexModule {
    private processing: boolean = false;

    get 処理中(): boolean {
        return this.processing;
    }

    @Mutation
    public async 開始する(): Promise<void> {
      this.processing = true;
    }

    @Mutation
    public async 終了する(): Promise<void> {
        this.processing = false;
    }
}

export const processModule = getModule(Process);
